import { Route, Routes } from 'react-router-dom';
import Category from './Category';
import Product from './Product';
import Festival from './Festival';
import FestivalDate from './FestivalDate';
import Requirement from './Requirement';
import ConsolidatedReport from './Report/ConsolidatedReport';
import DateWiseReport from './Report/DateWise';
import DateWiseConsolidatedReport from './Report/DateWiseConsolidated';

function FestivalRoutes() {
  return (
    <Routes>
      <Route path="category" element={<Category />} />
      <Route path="products" element={<Product />} />
      <Route path="festivals" element={<Festival />} />
      <Route path="dates" element={<FestivalDate />} />
      <Route path="requirements" element={<Requirement />} />
      <Route path="report/date-consolidated" element={<ConsolidatedReport />} />
      <Route path="report/date-wise" element={<DateWiseReport />} />
      <Route path="report/datewise-consolidated" element={<DateWiseConsolidatedReport />} />
    </Routes>
  );
}

export default FestivalRoutes;
